<template>
  <div :class="className">
    <video ref="videoPlayer" class="video-js" :class="videoClass" />
  </div>
</template>

<script>
import { videojs } from './plugin'
import 'video.js/dist/video-js.css'
import { cloneDeep } from 'lodash-es'

export default {
  name: 'VideoPlayer',
  props: {
    videoSrc: {
      type: String,
      default: ''
    },
    className: {
      type: String,
      defualt: ''
    },
    videoClass: {
      type: String,
      defualt: ''
    },
    options: {
      type: Object,
      default() {
        return {}
      }
    },
    autoplay: {
      type: Boolean,
      default: true
    },
    visible: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      // dialogVisible: false,
      defaultOpts: {
        flvjs: {
          mediaDataSource: {
            isLive: true,
            cors: true,
            withCredentials: false,
          }
        },
        controls: 'control',
        preload: 'auto',
        height: '508'
      }
    }
  },
  watch: {
    visible(newVal) {
      if (!newVal) {
        this.player.pause()
      }
    }
  },
  mounted() {
    this.initPlayer()
    if (this.autoplay) {
      this.play()
    }
  },

  beforeDestroy() {
    // 为了提高性能, 仅当组件销毁的时候才销毁player实例
    this.disposePlayer()
  },

  methods: {
    // 初始化player实例
    initPlayer() {
      if (!this.player) {
        const opts = Object.assign(cloneDeep(this.defaultOpts), this.options)
        this.player = videojs(this.$refs.videoPlayer, opts)

        if (this.isFlv(this.videoSrc)) {
        // flv 模式下跨域有点问题, 需要转换一下
          let url
          if (this.videoSrc.indexOf('/action/upload/cos_preview?url=') !== -1) {
            url = this.videoSrc
          } else {
            url = this.$toPreview(this.videoSrc)
          }
          this.player.src({
            src: url,
            type: 'video/x-flv'
          })
        } else {
          this.player.src(this.videoSrc)
        }
        this.player.load()
      }
    },

    // 销毁player实例
    disposePlayer() {
      if (this.player) {
        this.player.dispose()
      }
    },

    // 播放视频
    play() {
      this.player.play()
    },

    isFlv(url) {
      const reg = new RegExp(/\.flv/, 'i')
      return reg.test(url)
    },
  }
}
</script>
<style scoped lang="scss">
.video-js {
  width: 100%;
}
</style>
